// source: witbooking/backoffice/languages/v1/languages_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
goog.exportSymbol('proto.witbooking.backoffice.languages.v1.GetLanguageRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.languages.v1.GetLanguageResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.languages.v1.GetLanguagesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.languages.v1.GetLanguagesResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.languages.v1.Language', null, global);
goog.exportSymbol('proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.languages.v1.Language = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.languages.v1.Language, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.languages.v1.Language.displayName = 'proto.witbooking.backoffice.languages.v1.Language';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.languages.v1.GetLanguagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.displayName = 'proto.witbooking.backoffice.languages.v1.GetLanguagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.languages.v1.GetLanguageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.languages.v1.GetLanguageRequest.displayName = 'proto.witbooking.backoffice.languages.v1.GetLanguageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.languages.v1.GetLanguageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.languages.v1.GetLanguageResponse.displayName = 'proto.witbooking.backoffice.languages.v1.GetLanguageResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.languages.v1.GetLanguagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.displayName = 'proto.witbooking.backoffice.languages.v1.GetLanguagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.displayName = 'proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.displayName = 'proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.languages.v1.Language.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.languages.v1.Language} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.Language.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    code: jspb.Message.getFieldWithDefault(msg, 3, ""),
    primary: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    visible: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.languages.v1.Language}
 */
proto.witbooking.backoffice.languages.v1.Language.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.languages.v1.Language;
  return proto.witbooking.backoffice.languages.v1.Language.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.languages.v1.Language} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.languages.v1.Language}
 */
proto.witbooking.backoffice.languages.v1.Language.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPrimary(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVisible(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.languages.v1.Language.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.languages.v1.Language} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.Language.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPrimary();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getVisible();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.languages.v1.Language} returns this
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.languages.v1.Language} returns this
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string code = 3;
 * @return {string}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.languages.v1.Language} returns this
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool primary = 4;
 * @return {boolean}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.getPrimary = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.languages.v1.Language} returns this
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.setPrimary = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool active = 5;
 * @return {boolean}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.languages.v1.Language} returns this
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool visible = 6;
 * @return {boolean}
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.getVisible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.backoffice.languages.v1.Language} returns this
 */
proto.witbooking.backoffice.languages.v1.Language.prototype.setVisible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.languages.v1.GetLanguagesRequest;
  return proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.languages.v1.GetLanguageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.languages.v1.GetLanguageRequest;
  return proto.witbooking.backoffice.languages.v1.GetLanguageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.languages.v1.GetLanguageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguageRequest} returns this
 */
proto.witbooking.backoffice.languages.v1.GetLanguageRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.languages.v1.GetLanguageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: (f = msg.getLanguage()) && proto.witbooking.backoffice.languages.v1.Language.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguageResponse}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.languages.v1.GetLanguageResponse;
  return proto.witbooking.backoffice.languages.v1.GetLanguageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguageResponse}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.languages.v1.Language;
      reader.readMessage(value,proto.witbooking.backoffice.languages.v1.Language.deserializeBinaryFromReader);
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.languages.v1.GetLanguageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.languages.v1.Language.serializeBinaryToWriter
    );
  }
};


/**
 * optional Language language = 1;
 * @return {?proto.witbooking.backoffice.languages.v1.Language}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.prototype.getLanguage = function() {
  return /** @type{?proto.witbooking.backoffice.languages.v1.Language} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.languages.v1.Language, 1));
};


/**
 * @param {?proto.witbooking.backoffice.languages.v1.Language|undefined} value
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguageResponse} returns this
*/
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.prototype.setLanguage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguageResponse} returns this
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.prototype.clearLanguage = function() {
  return this.setLanguage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.languages.v1.GetLanguageResponse.prototype.hasLanguage = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    languagesList: jspb.Message.toObjectList(msg.getLanguagesList(),
    proto.witbooking.backoffice.languages.v1.Language.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.languages.v1.GetLanguagesResponse;
  return proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.languages.v1.Language;
      reader.readMessage(value,proto.witbooking.backoffice.languages.v1.Language.deserializeBinaryFromReader);
      msg.addLanguages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.languages.v1.Language.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Language languages = 1;
 * @return {!Array<!proto.witbooking.backoffice.languages.v1.Language>}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.prototype.getLanguagesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.languages.v1.Language>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.languages.v1.Language, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.languages.v1.Language>} value
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse} returns this
*/
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.prototype.setLanguagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.languages.v1.Language=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.languages.v1.Language}
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.prototype.addLanguages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.languages.v1.Language, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.languages.v1.GetLanguagesResponse} returns this
 */
proto.witbooking.backoffice.languages.v1.GetLanguagesResponse.prototype.clearLanguagesList = function() {
  return this.setLanguagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    language: (f = msg.getLanguage()) && proto.witbooking.backoffice.languages.v1.Language.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest;
  return proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.languages.v1.Language;
      reader.readMessage(value,proto.witbooking.backoffice.languages.v1.Language.deserializeBinaryFromReader);
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLanguage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.languages.v1.Language.serializeBinaryToWriter
    );
  }
};


/**
 * optional Language language = 1;
 * @return {?proto.witbooking.backoffice.languages.v1.Language}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.prototype.getLanguage = function() {
  return /** @type{?proto.witbooking.backoffice.languages.v1.Language} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.languages.v1.Language, 1));
};


/**
 * @param {?proto.witbooking.backoffice.languages.v1.Language|undefined} value
 * @return {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} returns this
*/
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest} returns this
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.prototype.clearLanguage = function() {
  return this.setLanguage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageRequest.prototype.hasLanguage = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse;
  return proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.languages.v1.UpdateLanguageResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.witbooking.backoffice.languages.v1);
